import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { GetSessionAnalysisRes } from "../../../../../../api/ai/types";
import Logo from "../../../../../../images/icons/logo.png";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#f9fafb",
    padding: 20,
    fontFamily: "Helvetica",
  },
  header: {
    backgroundColor: "white",
    padding: 20,
    borderRadius: 8,
    marginBottom: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#111827",
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 14,
    color: "#6b7280",
  },
  section: {
    backgroundColor: "white",
    padding: 20,
    borderRadius: 8,
    marginBottom: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    border: "1px solid #e5e7eb",
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#111827",
    marginBottom: 16,
    flexDirection: "row",
    alignItems: "center",
  },
  sectionSubTitle: {
    // fontSize: 14,
    // fontWeight: "bold",
    // color: "#111827",
    // marginBottom: 12,
    fontSize: 14,
    fontWeight: "bold",
    color: "#111827",
    marginBottom: 12,
  },
  sectionIcon: {
    width: 16,
    height: 16,
    marginRight: 8,
  },
  scoreContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
    paddingVertical: 16,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#e5e7eb",
  },
  //   scoreLabel: {
  //     fontSize: 16,
  //     fontWeight: "600",
  //     color: "#111827",
  //   },
  scoreValue: {
    fontSize: 16,
    fontWeight: "bold",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 20,
  },
  scoreHigh: {
    backgroundColor: "#dcfce7",
    color: "#166534",
  },
  scoreMedium: {
    backgroundColor: "#dbeafe",
    color: "#1d4ed8",
  },
  scoreLow: {
    backgroundColor: "#fed7aa",
    color: "#c2410c",
  },
  scoreVeryLow: {
    backgroundColor: "#fecaca",
    color: "#dc2626",
  },
  summary: {
    fontSize: 12,
    color: "#374151",
    lineHeight: 1.5,
    marginBottom: 16,
  },
  statsGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
  },
  statItem: {
    flexDirection: "row",
    alignItems: "center",
    minWidth: "45%",
    marginBottom: 12,
  },
  statIcon: {
    width: 32,
    height: 32,
    backgroundColor: "#f3f4f6",
    borderRadius: 6,
    marginRight: 12,
    justifyContent: "center",
    alignItems: "center",
  },
  statLabel: {
    fontSize: 10,
    color: "#6b7280",
    marginBottom: 2,
  },
  statValue: {
    fontSize: 12,
    fontWeight: "600",
    color: "#111827",
  },
  twoColumnGrid: {
    flexDirection: "column",
    gap: 20,
  },
  column: {
    // flex: 1,
  },
  responseCard: {
    borderWidth: 1,
    borderRadius: 8,
    padding: 12,
    marginBottom: 12,
  },
  strongResponseCard: {
    borderColor: "#bbf7d0",
    backgroundColor: "#f0fdf4",
  },
  weakResponseCard: {
    borderColor: "#fecaca",
    backgroundColor: "#fef2f2",
  },
  responseHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
  },
  responseNumber: {
    fontSize: 10,
    color: "white",
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 10,
    fontWeight: "600",
  },
  strongResponseNumber: {
    backgroundColor: "#16a34a",
  },
  weakResponseNumber: {
    backgroundColor: "#dc2626",
  },
  responseScore: {
    fontSize: 10,
    fontWeight: "600",
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 10,
  },
  responseQuestion: {
    fontSize: 12,
    fontWeight: "600",
    color: "#111827",
    marginBottom: 6,
  },
  responseFeedback: {
    fontSize: 10,
    color: "#4b5563",
    lineHeight: 1.4,
  },
  topicCard: {
    borderWidth: 1,
    borderColor: "#e5e7eb",
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
  },
  topicHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 12,
  },
  topicTitle: {
    fontSize: 14,
    fontWeight: "600",
    color: "#111827",
    marginBottom: 4,
  },
  topicSubText: {
    fontSize: 10,
    color: "#6b7280",
  },
  topicScoreContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  topicScore: {
    fontSize: 10,
    fontWeight: "600",
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 10,
  },
  topicQuestions: {
    fontSize: 8,
    color: "#6b7280",
  },
  progressBar: {
    width: "100%",
    height: 6,
    backgroundColor: "#e5e7eb",
    borderRadius: 3,
    marginBottom: 12,
  },
  progressFill: {
    height: "100%",
    borderRadius: 3,
  },
  progressHigh: {
    backgroundColor: "#22c55e",
  },
  progressMedium: {
    backgroundColor: "#3b82f6",
  },
  progressLow: {
    backgroundColor: "#f59e0b",
  },
  progressVeryLow: {
    backgroundColor: "#ef4444",
  },
  strengthsImprovements: {
    flexDirection: "row",
    gap: 12,
  },
  strengthsColumn: {
    flex: 1,
  },
  improvementsColumn: {
    flex: 1,
  },
  columnTitle: {
    fontSize: 10,
    fontWeight: "600",
    marginBottom: 6,
    flexDirection: "row",
    alignItems: "center",
  },
  strengthTitle: {
    color: "#15803d",
  },
  improvementTitle: {
    color: "#c2410c",
  },
  listItem: {
    fontSize: 9,
    color: "#4b5563",
    marginBottom: 3,
    paddingLeft: 8,
  },
  emptyState: {
    textAlign: "center",
    padding: 20,
    borderWidth: 1,
    borderColor: "#e5e7eb",
    borderRadius: 8,
    backgroundColor: "#f9fafb",
  },
  emptyStateText: {
    fontSize: 12,
    color: "#6b7280",
    fontWeight: "500",
    marginBottom: 4,
  },
  emptyStateSubtext: {
    fontSize: 10,
    color: "#9ca3af",
  },
});

interface Props {
  sessionAnalysisData: GetSessionAnalysisRes;
}

const AnalyticsPDFDocument: React.FC<Props> = ({ sessionAnalysisData }) => {
  const getScoreStyle = (score: number) => {
    if (score >= 80) return styles.scoreHigh;
    if (score >= 70) return styles.scoreMedium;
    if (score >= 60) return styles.scoreLow;
    return styles.scoreVeryLow;
  };

  const getProgressStyle = (score: number) => {
    if (score >= 80) return styles.progressHigh;
    if (score >= 70) return styles.progressMedium;
    if (score >= 60) return styles.progressLow;
    return styles.progressVeryLow;
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Image
          style={{
            width: "170px",
            height: "35px",
            margin: "auto",
          }}
          src={Logo}
        />

        {/* Header */}
        <View style={styles.header}>
          <Text style={styles.title}>Interview Analytics</Text>
          <Text style={styles.subtitle}>
            Comprehensive analysis of your interview performance
          </Text>
        </View>

        {/* Session Summary */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Session Summary</Text>

          <View style={styles.scoreContainer}>
            <Text style={styles.sectionSubTitle}>Overall Performance</Text>
            <Text
              style={[
                styles.scoreValue,
                getScoreStyle(sessionAnalysisData.sessionData.overallScore),
              ]}
            >
              {sessionAnalysisData.sessionData.overallScore}%
            </Text>
          </View>

          <View style={styles.progressBar}>
            <View
              style={[
                styles.progressFill,
                getProgressStyle(sessionAnalysisData.sessionData.overallScore),
                { width: `${sessionAnalysisData.sessionData.overallScore}%` },
              ]}
            />
          </View>

          <Text style={styles.summary}>
            {sessionAnalysisData.sessionData.summary}
          </Text>

          <View style={styles.statsGrid}>
            <View style={styles.statItem}>
              {/* <View style={styles.statIcon}>
                <Text>Date</Text>
              </View> */}
              <View>
                <Text style={styles.statLabel}>Date & Time</Text>
                <Text style={styles.statValue}>
                  {sessionAnalysisData.sessionData.date}
                </Text>
              </View>
            </View>

            <View style={styles.statItem}>
              {/* <View style={styles.statIcon}>
                <Text>Time</Text>
              </View> */}
              <View>
                <Text style={styles.statLabel}>Duration</Text>
                <Text style={styles.statValue}>
                  {sessionAnalysisData.sessionData.duration}
                </Text>
              </View>
            </View>

            <View style={styles.statItem}>
              {/* <View style={styles.statIcon}>
                <Text>Q&A</Text>
              </View> */}
              <View>
                <Text style={styles.statLabel}>Questions Asked</Text>
                <Text style={styles.statValue}>
                  {sessionAnalysisData.sessionData.totalQuestions}
                </Text>
              </View>
            </View>

            <View style={styles.statItem}>
              {/* <View style={styles.statIcon}>
                <Text>Type</Text>
              </View> */}
              <View>
                <Text style={styles.statLabel}>Interview Type</Text>
                <Text style={styles.statValue}>
                  {sessionAnalysisData.sessionData.interviewType}
                </Text>
              </View>
            </View>
          </View>
        </View>

        {/* Behavioral Insights */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Behavioral Insights</Text>

          <View style={styles.twoColumnGrid}>
            {/* Strongest Responses */}
            <View style={styles.column}>
              <Text style={[styles.sectionSubTitle, { color: "#15803d" }]}>
                Strongest Responses
              </Text>

              {sessionAnalysisData.strongestResponses &&
              sessionAnalysisData.strongestResponses.length > 0 ? (
                sessionAnalysisData.strongestResponses.map(
                  (response: any, index: number) => (
                    <View
                      key={index}
                      style={[styles.responseCard, styles.strongResponseCard]}
                    >
                      <View style={styles.responseHeader}>
                        <Text
                          style={[
                            styles.responseNumber,
                            styles.strongResponseNumber,
                          ]}
                        >
                          #{index + 1}
                        </Text>
                        <Text
                          style={[
                            styles.responseScore,
                            getScoreStyle(response.score),
                          ]}
                        >
                          {response.score}%
                        </Text>
                      </View>
                      <Text style={styles.responseQuestion}>
                        {response.question}
                      </Text>
                      <Text style={styles.responseFeedback}>
                        {response.feedback}
                      </Text>
                    </View>
                  )
                )
              ) : (
                <View style={styles.emptyState}>
                  <Text style={styles.emptyStateText}>
                    No standout responses identified
                  </Text>
                </View>
              )}
            </View>

            {/* Areas for Improvement */}
            <View style={styles.column}>
              <Text style={[styles.sectionSubTitle, { color: "#dc2626" }]}>
                Areas for Improvement
              </Text>

              {sessionAnalysisData.weakestResponses &&
              sessionAnalysisData.weakestResponses.length > 0 ? (
                sessionAnalysisData.weakestResponses.map(
                  (response: any, index: number) => (
                    <View
                      key={index}
                      style={[styles.responseCard, styles.weakResponseCard]}
                    >
                      <View style={styles.responseHeader}>
                        <Text
                          style={[
                            styles.responseNumber,
                            styles.weakResponseNumber,
                          ]}
                        >
                          #{index + 1}
                        </Text>
                        <Text
                          style={[
                            styles.responseScore,
                            getScoreStyle(response.score),
                          ]}
                        >
                          {response.score}%
                        </Text>
                      </View>
                      <Text style={styles.responseQuestion}>
                        {response.question}
                      </Text>
                      <Text style={styles.responseFeedback}>
                        {response.feedback}
                      </Text>
                    </View>
                  )
                )
              ) : (
                <View style={styles.emptyState}>
                  <Text style={styles.emptyStateText}>
                    No significant areas for improvement identified
                  </Text>
                </View>
              )}
            </View>
          </View>
        </View>

        {/* Topic Proficiency Breakdown */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Topic Proficiency Breakdown</Text>
          <Text style={styles.summary}>
            This section provides an overview of your proficiency in various
            topics based on the session analysis.
          </Text>

          {sessionAnalysisData.topicProficiencies &&
          sessionAnalysisData.topicProficiencies.length > 0 ? (
            sessionAnalysisData.topicProficiencies.map(
              (topic: any, index: number) => (
                <View key={index} style={styles.topicCard}>
                  <View style={styles.topicHeader}>
                    <View style={{ flex: 1 }}>
                      <Text style={styles.topicTitle}>{topic.topic}</Text>
                      <Text style={styles.topicSubText}>{topic.subText}</Text>
                    </View>
                    <View style={styles.topicScoreContainer}>
                      <Text
                        style={[styles.topicScore, getScoreStyle(topic.score)]}
                      >
                        {topic.score}%
                      </Text>
                      <Text style={styles.topicQuestions}>
                        ({topic.questionsAsked} questions)
                      </Text>
                    </View>
                  </View>

                  <View style={styles.progressBar}>
                    <View
                      style={[
                        styles.progressFill,
                        getProgressStyle(topic.score),
                        { width: `${topic.score}%` },
                      ]}
                    />
                  </View>

                  <View style={styles.strengthsImprovements}>
                    <View style={styles.strengthsColumn}>
                      <Text style={[styles.columnTitle, styles.strengthTitle]}>
                        Strengths
                      </Text>
                      {topic.strengths && topic.strengths.length > 0 ? (
                        topic.strengths.map((strength: string, idx: number) => (
                          <Text key={idx} style={styles.listItem}>
                            • {strength}
                          </Text>
                        ))
                      ) : (
                        <Text
                          style={[styles.listItem, { fontStyle: "italic" }]}
                        >
                          No specific strengths identified
                        </Text>
                      )}
                    </View>

                    <View style={styles.improvementsColumn}>
                      <Text
                        style={[styles.columnTitle, styles.improvementTitle]}
                      >
                        Improvements
                      </Text>
                      {topic.improvements && topic.improvements.length > 0 ? (
                        topic.improvements.map(
                          (improvement: string, idx: number) => (
                            <Text key={idx} style={styles.listItem}>
                              • {improvement}
                            </Text>
                          )
                        )
                      ) : (
                        <Text
                          style={[styles.listItem, { fontStyle: "italic" }]}
                        >
                          No specific improvements identified
                        </Text>
                      )}
                    </View>
                  </View>
                </View>
              )
            )
          ) : (
            <View style={styles.emptyState}>
              <Text style={styles.emptyStateText}>
                No topic proficiency data available
              </Text>
              <Text style={styles.emptyStateSubtext}>
                Topics will be analyzed as more interview data becomes available
              </Text>
            </View>
          )}
        </View>
      </Page>
    </Document>
  );
};

export default AnalyticsPDFDocument;
